import React from 'react';
import bioMarkerData from '../../components/data/biomarker-nuero.json';
// import isWithinTargetRange from './targetRange';
// import getChangeIcon from './getChangeIcon';
import { countBioMarkers } from './countBiomarkers';
import { displayValue, displayTarget, displayChange } from './displayItems';

export const neuroCounts = countBioMarkers(bioMarkerData);

const BioMarkersNeuro = () => {
  const { totalMarkers, notMeasured, redFlags, greenCount, targetRange } = countBioMarkers(bioMarkerData);

  return (
    <div className="section" id="bio-markers">
      <h2>Bio Markers - Neurological & Cognitive Function</h2>
      <p>This system focuses on brain plasticity, cognitive performance, and neuroprotection. It encompasses the nervous system, optimizing memory, focus, stress resilience, and synaptic health to support lifelong mental clarity and adaptability.</p>
      <div className="card-container">
        <h3>Neuro Markers: {totalMarkers}</h3>
        <h3>Not Measured: {notMeasured}</h3>
        <h3>Red Flags: <span style={{ color: "#ff3300" }}>{redFlags}</span></h3>
        <h3>Within Range: {targetRange}</h3>
        <h3>On Target: <span style={{ color: "#77b300" }}>{greenCount}</span></h3>
      </div>
      <div className="ai-prompt-table">
        <div className="table-header">
          <div className="table-title-bio">Marker</div>
          <div className="table-title-bio">Value</div>
          <div className="table-title-bio">Reference Target</div>
          <div className="table-title-bio">User Target</div>
          <div className="table-title-bio">Tested</div>
          <div className="table-title-bio-short">Change</div>
        </div>
        {bioMarkerData.map((bioMarker, index) => (
          <div className="table-row" key={index}>
            <div className="table-content">{bioMarker.marker}</div>
            <div className="table-content">{displayValue(bioMarker.value, bioMarker)}</div>
            <div className="table-content">{displayTarget(bioMarker.target, bioMarker, 'reference')}</div>
            <div className="table-content">{displayTarget(bioMarker.target, bioMarker, 'user')}</div>
            <div className="table-content">{bioMarker.tested.last}</div>
            <div className="table-content-short">{displayChange(bioMarker.change, bioMarker)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BioMarkersNeuro;